import script from "./SettingsEmploymentReferenceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsEmploymentReferenceSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsEmploymentReferenceSection.vue?vue&type=style&index=0&id=34867e38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34867e38"]])

export default __exports__